<script setup lang="ts">
import { ref, onMounted, onBeforeUnmount, nextTick, watch } from 'vue';

const wrapper = ref<HTMLElement | null>(null);
const isDropdownOpen = ref(false);

const dropdownStyles = ref<Record<string, string>>({});
const dropdown = ref<HTMLElement | null>(null);

function positionDropdown() {
  if (wrapper.value && dropdown.value) {
    const anchorRect = wrapper.value.getBoundingClientRect();
    const dropRect = dropdown.value.getBoundingClientRect();
    dropdownStyles.value = {
      position: 'absolute',
      top: `${anchorRect.bottom + window.scrollY}px`,
      left: `${anchorRect.left + window.scrollX + anchorRect.width / 2 - dropRect.width / 2}px`,
      zIndex: '1000',
    };
  }
}

defineExpose({
  isDropdownOpen,
});

watch(isDropdownOpen, async (open) => {
  if (open) {
    await nextTick();
    positionDropdown();
  }
});

function handleClickOutside(event: MouseEvent) {
  if (
    wrapper.value &&
    !wrapper.value.contains(event.target as Node) &&
    dropdown.value &&
    !dropdown.value.contains(event.target as Node)
  ) {
    isDropdownOpen.value = false;
  }
}

onMounted(() => document.addEventListener('click', handleClickOutside));
onBeforeUnmount(() => document.removeEventListener('click', handleClickOutside));
</script>
<template>
  <div ref="wrapper" class="dropdown-wrapper">
    <div class="dropdown-root" @click="isDropdownOpen = !isDropdownOpen">
      <slot name="menu" :is-dropdown-open="isDropdownOpen" />
    </div>
    <teleport to="body">
      <transition name="dropdown">
        <div v-if="isDropdownOpen" ref="dropdown" class="dropdown-content" :style="dropdownStyles">
          <slot name="dropdown" />
        </div>
      </transition>
    </teleport>
  </div>
</template>
<style scoped>
.dropdown-root {
  overflow: hidden;
  cursor: pointer;
}
.dropdown-wrapper {
  position: relative;
  display: inline-block;
}

.dropdown-content {
  position: absolute;
  top: 100%;
  left: 0;
  margin-top: 4px;
  z-index: 1000;
}
.icon {
  display: inline-block;
  transition: transform 0.2s ease;
}
.dropdown-enter-from {
  opacity: 0;
  transform: translateY(-10px);
}
.dropdown-enter-active {
  transition:
    opacity 0.2s ease-out,
    transform 0.2s ease-out;
}
.dropdown-enter-to {
  opacity: 1;
  transform: translateY(0);
}
.dropdown-leave-from {
  opacity: 1;
  transform: translateY(0);
}
.dropdown-leave-active {
  transition:
    opacity 0.15s ease-in,
    transform 0.15s ease-in;
}
.dropdown-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}
</style>
